import React, { useState, useEffect } from 'react';
import { IoCloseOutline as Close } from 'react-icons/io5';
import LabelIcon from '@mui/icons-material/Label';
import { BsPersonCircle as ProfilePicture } from 'react-icons/bs';
import { BsBuilding as Organizations } from 'react-icons/bs';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Modal from '@mui/material/Modal';
import LinearProgress from '@mui/material/LinearProgress';
import LabelCardService from '@Helpers/URLHelpers/WeboutService/LabelCardService';
import NameCardService from '@Helpers/URLHelpers/WeboutService/NameCardService';
import ErrorHandler from '@Root/ErrorHandler';
import './LabelClickUpMenu.scss';

export default function LabelClickUpMenu(props) {

    const [imageUrl, setImageUrl] = useState('');
    const [viewLoader, setViewLoader] = useState(false);
    const [expandLabelClickMenu, setExpandLabelClickMenu] = useState(false);
    const [labelData, setLabelData] = useState({});
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
            '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
           '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
            '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    const labelCardService = new LabelCardService();
    const nameCardService = new NameCardService();
    const errorHandler = new ErrorHandler();
    const className = 'labelClickMenu';

    useEffect(()=>{
        renderData();
    },[props])

    const renderData = async ()=> {
        if(props?.history) {
           await handleLabelClick(props?.history?.registryType, props?.history?.registryId);
        }
    }

    const getInitials = (string) => {
        var names = string.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    };

    const toggleShowLabelView = () => {
        handleLabelClick(props?.label?.registryType, props?.label?.registryId);
        handleExpandLabelClickMenu()
    }

    const handleLabelClick = async (registryType, id) => {
        setViewLoader(true);
        let labelObj;
        try {
            switch(registryType){
                case 'labelCard' :
                    labelObj = await labelCardService.getById(id);
                    break;
                case 'nameCard' :
                    labelObj = await nameCardService.getById(id);
                    break;
                default : break;
            }
            setLabelData(JSON.parse(labelObj?.body));
        } catch (err) {
            errorHandler.handleError(err);
        }
        if(!!props?.history || !!props?.label?.photo) {
            if(labelData?.photo !== null && labelData?.photo !== undefined && labelData?.photo !== 'N/A'){
                setImageUrl(URL.createObjectURL(dataURLtoFile(labelData?.photo)));
            }   else {
                setImageUrl('');
            }
        }
        setViewLoader(false);
    }

    const handleExpandLabelClickMenu = ()=> {
        setExpandLabelClickMenu(!expandLabelClickMenu);
    }

	const dataURLtoFile = (dataurl) => {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], { type: mime });
	};

    const getContrastYIQ = (hexcolor) => {
        var r = parseInt(hexcolor.substring(1,3),16);
        var g = parseInt(hexcolor.substring(3,5),16);
        var b = parseInt(hexcolor.substring(5,7),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq <= 128) ? 'white' : 'black';
    }


    return (
        <>
            {
                props?.label &&
                    <Chip
                        label={
                            <div className={className + '__chip__label flex-row-center-1vw-gap'}>
                                <div className={className + '__chip__label__t1'} style={{color: getContrastYIQ(colorList[props?.label.name.charCodeAt(0) % colorList.length])}}>
                                    {props?.label.name}
                                </div>
                            </div>
                        }
                        variant='standard'
                        color='primary'
                        size='small'
                        sx={{ bgcolor: colorList[props?.label.name.charCodeAt(0) % colorList.length] + ' !important'}}
                        onClick={toggleShowLabelView}
                        avatar={
                            props?.label?.registryType === 'nameCard' ?
                            (
                                props?.label?.photo !== null && props?.label?.photo !== undefined && props?.label?.photo !== 'N/A' ?
                                    <Avatar src={URL.createObjectURL(dataURLtoFile(props?.label?.photo))}/>
                                :
                                    <Avatar sx={{ bgcolor: colorList[props?.label.name.charCodeAt(0) % colorList.length] + ' !important'}}>{getInitials(props?.label?.name)}</Avatar>
                            )
                            :
                                null
                        }
                        onDelete={props?.handleDeleteLabelRegistryClick && (()=> props?.handleDeleteLabelRegistryClick(props?.label.id))} />
            }
            {
                (props?.history && labelData.length !== 0 ?
                    <Chip
                        label={
                            <div className={className + '__chip__label flex-row-center-1vw-gap'}>
                                <div className={className + '__chip__label__t1'}
                                    onClick={handleExpandLabelClickMenu}>
                                    { labelData?.name }
                                </div>
                            </div>
                        }
                        variant='outlined'
                        color='primary'
                        size='small'
                        avatar={
                            props?.history?.registryType === 'nameCard' ?
                            (
                                labelData?.photo !== null && labelData?.photo !== undefined && labelData?.photo !== 'N/A' ?
                                    <Avatar src={URL.createObjectURL(dataURLtoFile(labelData?.photo))}/>
                                :
                                    <Avatar sx={{ bgcolor: colorList[labelData?.name?.charCodeAt(0) % colorList.length] + ' !important'}}>{labelData?.name ? getInitials(labelData.name) : 'U'}</Avatar>
                            )
                            :
                                props?.history?.registryType === 'labelCard' ?
                                    <Avatar sx={{ bgcolor: colorList[labelData?.name?.charCodeAt(0) % colorList.length] + ' !important'}}><LabelOutlinedIcon/></Avatar>
                                :
                                    null
                        } />
                :
                    null)
            }
            {
                expandLabelClickMenu &&
                    <Modal
                        open={expandLabelClickMenu}
                        onClose={handleExpandLabelClickMenu}
                        className={className + ' flex-row-center width-wfa'}>
                            <div className={className + '__inner'}>
                                <div className={className + '__inner__top flex-row-center'}>
                                    <div className={className + '__inner__top__name'}>
                                        {
                                            props?.label?.registryType === 'labelCard' ?
                                                <div className={className + '__inner__top__type flex-row-center-1vw-gap'}>
                                                    <LabelIcon className={className + '__inner__top__type__icon opacity-0p6'}/>
                                                    <div className={className + '__inner__top__type__t1'}>
                                                        {labelData?.name}
                                                    </div>
                                                </div>
                                            :
                                                <div className={className + '__inner__top__type flex-row-center-1vw-gap'}>
                                                    <ProfilePicture className={className + '__inner__top__type__icon opacity-0p6'}/>
                                                    <div className={className + '__inner__top__type__t1'}>
                                                        {labelData?.name}
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                    <Close className={className + '__inner__top__closeIcon close-button'}
                                            onClick={handleExpandLabelClickMenu}/>
                                </div>
                                {
                                    viewLoader ?
                                        <div className={className + '__inner__loaders'}>
                                            <LinearProgress className={className + '__inner__loaders__loader width-wfa default-loader'} color='inherit'/>
                                            <div className={className + '__inner__loaders__t1'}>
                                                Loading...
                                            </div>
                                        </div>
                                    :
                                        <div className={className + '__inner__body'}>
                                             {
                                                (props?.label?.registryType === 'labelCard' || props?.history?.registryType === 'labelCard') &&
                                                    <>
                                                        <div className={className + '__inner__body__left flex-row-center width-wfa'}>
                                                            <div className={className + '__inner__body__left__icon flex-row-center-1vw-gap'}>
                                                                <LabelIcon className={className + '__inner__body__left__icon opacity-0p6'}/>
                                                            </div>
                                                            <div className={className + '__inner__body__right flex-column-flex-start-1vh-gap'}>
                                                                <div className={className + '__inner__body__right__name flex-row-center-1vw-gap standard-text-large semi-bold-text'}>
                                                                    <div className={className + '__inner__body__right__name__value blue-text'}>
                                                                        {labelData?.name}
                                                                    </div>
                                                                </div>
                                                                <div className={className + '__inner__body__right__created flex-row-center-1vw-gap standard-text-small grey-text'}>
                                                                    <div className={className + '__inner__body__right__created__t1 semi-bold-text'}>
                                                                        Created
                                                                    </div>
                                                                    <div className={className + '__inner__body__right__created__value'}>
                                                                        {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(labelData?.createTimeStamp)}
                                                                    </div>
                                                                </div>
                                                                <div className={className + '__inner__body__right__created flex-row-center-1vw-gap standard-text-small grey-text'}>
                                                                    <div className={className + '__inner__body__right__created__t1 semi-bold-text'}>
                                                                        Updated
                                                                    </div>
                                                                    <div className={className + '__inner__body__right__created__value'}>
                                                                        {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(labelData?.modifiedTimeStamp)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={className + '__inner__body__remarks flex-column-flex-start-2vh-gap width-wfa'}>
                                                            {
                                                                !!labelData?.remarks &&
                                                                    <div className={className + '__inner__body__remarks flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__remarks__t1 semi-bold-text'}>
                                                                            Remarks
                                                                        </div>
                                                                        <div className={className + '__inner__body__remarks__value'}>
                                                                            {labelData?.remarks}
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </>
                                             }
                                             {
                                                (props?.label?.registryType === 'nameCard' || props?.history?.registryType === 'nameCard') &&
                                                    <>
                                                        <div className={className + '__inner__body__left flex-row-center-1vw-gap width-wfa'}>
                                                            <div className={className + '__inner__body__left__icon flex-row-center-1vw-gap'}>
                                                                {
                                                                    imageUrl !== undefined && imageUrl !== '' ?
                                                                        <img
                                                                            src={imageUrl}
                                                                            className={className + '__inner__body__left__img'}
                                                                            alt='profile'/>
                                                                    :
                                                                        <ProfilePicture className={className + '__inner__body__left__icon opacity-0p6'}/>
                                                                }
                                                            </div>
                                                            <div className={className + '__inner__body__right flex-column-flex-start-1vh-gap'}>
                                                                <div className={className + '__inner__body__right__name flex-row-center-1vw-gap standard-text-large semi-bold-text'}>
                                                                    <div className={className + '__inner__body__right__name__value blue-text'}>
                                                                        {labelData?.name}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    (!!labelData?.designation) &&
                                                                        <div className={className + '__inner__body__right__org flex-row-center-1vw-gap'}>
                                                                            <div className={className + '__inner__body__right__org__t1 grey-text semi-large-text'}>
                                                                                {labelData?.designation}
                                                                            </div>
                                                                        </div>
                                                                }
                                                                <div className={className + '__inner__body__right__created flex-row-center-1vw-gap standard-text-small grey-text'}>
                                                                    <div className={className + '__inner__body__right__created__t1 semi-bold-text'}>
                                                                        Created
                                                                    </div>
                                                                    <div className={className + '__inner__body__right__created__value'}>
                                                                        {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(labelData?.createTimeStamp)}
                                                                    </div>
                                                                </div>
                                                                <div className={className + '__inner__body__right__created flex-row-center-1vw-gap standard-text-small grey-text'}>
                                                                    <div className={className + '__inner__body__right__created__t1 semi-bold-text'}>
                                                                        Updated
                                                                    </div>
                                                                    <div className={className + '__inner__body__right__created__value'}>
                                                                        {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(labelData?.modifiedTimeStamp)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={className + '__inner__body__info flex-column-flex-start-2vh-gap width-wfa'}>
                                                            {
                                                                !!labelData?.email &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Email
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.email}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.department &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Department
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.department}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.branch &&
                                                                    <div className={className + '__inner__body__info__branch flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__branch__t1 semi-bold-text'}>
                                                                            Branch
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__branch__value'}>
                                                                            {labelData?.branch}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.contactNumber &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Contact Number
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.contactNumber}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.address &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Address
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.address}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.pinCode &&
                                                                    <div className={className + '__inner__body__info__pinCode flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__pinCode__t1 semi-bold-text'}>
                                                                            Pin Code
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__pinCode__value'}>
                                                                            {labelData?.pinCode}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.country &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Country
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.country}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.state &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            State
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.state}
                                                                        </div>
                                                                    </div>
                                                            }
                                                            {
                                                                !!labelData?.remarks &&
                                                                    <div className={className + '__inner__body__info__email flex-column-flex-start-1vh-gap'}>
                                                                        <div className={className + '__inner__body__info__email__t1 semi-bold-text'}>
                                                                            Remarks
                                                                        </div>
                                                                        <div className={className + '__inner__body__info__email__value'}>
                                                                            {labelData?.remarks}
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </>
                                             }
                                        </div>
                                }
                            </div>
                    </Modal>
        }
        </>
    )
}